// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vy0FN","footer":"styles_footer__2-OWI"};